"use client";

import type { QueryClient } from "@tanstack/react-query";
import { workspaceAppsKeys } from "../queryKeys";

export async function invalidateWorkspaceApps(
  queryClient: QueryClient,
  workspaceUuid: string,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: workspaceAppsKeys.effectiveAll(workspaceUuid) }),
    queryClient.invalidateQueries({ queryKey: workspaceAppsKeys.catalog(workspaceUuid) }),
    queryClient.invalidateQueries({ queryKey: workspaceAppsKeys.presets(workspaceUuid) }),
    queryClient.invalidateQueries({ queryKey: workspaceAppsKeys.installations(workspaceUuid) }),
  ]);
}
